import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHourgrass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M8 10h8l-1 2H9l-1-2ZM6 19.3h12v2H6v-2Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4 1.25a.75.75 0 0 0 0 1.5h1.25c0 1.88.016 3.692.535 5.327.479 1.508 1.372 2.836 2.961 3.993a9.796 9.796 0 0 0-1.902 2.44c-.876 1.578-1.556 3.753-1.593 6.74H4a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5h-1.252c-.036-2.987-.716-5.162-1.592-6.74a9.797 9.797 0 0 0-1.902-2.44c1.589-1.157 2.482-2.485 2.96-3.993.52-1.635.536-3.447.536-5.327H20a.75.75 0 0 0 0-1.5H4Zm13.25 1.5H6.75c.001 1.917.026 3.49.465 4.873.44 1.386 1.314 2.62 3.17 3.734a.75.75 0 0 1 .065 1.243 8.215 8.215 0 0 0-2.294 2.64c-.744 1.338-1.369 3.26-1.404 6.01h10.496c-.035-2.75-.66-4.672-1.404-6.01a8.215 8.215 0 0 0-2.294-2.64.75.75 0 0 1 .064-1.243c1.857-1.114 2.731-2.348 3.171-3.734.44-1.383.464-2.956.465-4.873Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorHourgrass;
